import api from "../../API/apiConfig";

// 1. Lấy danh sách Campaigns
export const getCampaigns = (filter) => {
  return api.get(`/campaigns`, {params: filter});
};

// 2. Thêm mới Campaign
export const addCampaign = (campaignData) => {
  return api.post("/campaigns/add", campaignData);
};

// 3. Cập nhật Campaign theo ID
export const updateCampaign = (id, campaignData) => {
  return api.put(`/campaigns/update/${id}`, campaignData);
};

// 4. Xóa Campaign theo ID
export const deleteCampaign = (id) => {
  return api.delete(`/campaigns/delete/${id}`);
};

// 5. Xem chi tiết một Campaign theo ID
export const getCampaignDetail = (id) => {
  return api.get(`/campaigns/detail/${id}`);
};

// 6. Xem thông tin tổng quan campaign
export const getCampaignHeader = (id) => {
  return api.get(`/campaigns/header-campaign`);
};
// 7. Get All Mail template
export const getMailTemplates = () => {
  return api.get(`/email/list-all-template`)
}
// 8. Send bulk
export const sendBulk = (data) => {
  return api.post("/email/send-bulk", data);
};
